<template>
  <div>
    <wt-check-box
      label-right="All"
      v-model="allProvidersChecked"
    ></wt-check-box>
    <div v-for="(provider, i) in providers" :key="i">
      <wt-check-box
        :title="providerTitle(provider)"
        v-model="provider.selected"
        :label-right="providerLabel(provider)"
        @changed="providerChanged(provider.id, $event)"
      ></wt-check-box>
    </div>
  </div>
</template>

<script>
import app from 'app';
export default {
  data() {
    return {};
  },

  analytics: {
    filterByProvider: 'Filter By Provider',
  },

  computed: Object.assign(
    {
      providers() {
        return this.contextFilters.providers;
      },
      allProvidersChecked: {
        get() {
          return !_.find(this.providers, (p) => !p.selected);
        },
        set(newValue) {
          const shouldSelect = newValue;
          this.providers.forEach((tmpProvider) => {
            this.SET_PROVIDER_SELECTION({
              id: tmpProvider.id,
              selected: shouldSelect,
            });
          });
          this.sendEvent();
          this.$emit('search');
        },
      },
    },
    app.Vuex.mapGetters(['contextFilters', 'assetsSource'])
  ),

  props: {},

  methods: Object.assign(
    {
      providerLabel(provider) {
        return `
          <img src="${app.prependHttp(
            provider.logoUrl
          )}" width="16" height="16">
          ${provider.displayText}
        `;
      },

      providerTitle(provider) {
        return provider.displayText.length > 23 ? provider.displayText : null;
      },

      providerChanged(id, selected) {
        this.SET_PROVIDER_SELECTION({ id, selected });
        this.sendEvent();
        this.$emit('search');
      },

      sendEvent() {
        let partial = false;
        let i = -1;
        while (++i < this.providers.length - 1) {
          if (this.providers[i].selected !== this.providers[i + 1].selected) {
            partial = true;
            break;
          }
        }
        this.$triggerAnalytics('filterByProvider', {
          Selection: partial ? 'partial' : 'all',
          'All checkbox checked': this.allProvidersChecked,
        });
      },
    },
    app.Vuex.mapActions(['SET_PROVIDER_SELECTION'])
  ),
};
</script>
